import { httpGet } from "@/src/api/http";
import type { GetRes } from "@/src/api/types";

/** Runtime SLA configuration, so the report page needs no build-time env vars. */
export function getSlaConfig() {
    return httpGet<GetRes<"monitoring/sla-config/">>(`monitoring/sla-config/`);
}

/**
 * The `type` parameter selects both the metric and the response shape; see the contract for the
 * variants (`uptime`/`latency`/`both`, `cr_job_success`, `exec_time`, `slo_health`, `slo_budget`).
 */
export function getMetrics(params: Record<string, string | number | undefined>) {
    const query = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== "") as [string, string][],
    );
    return httpGet<GetRes<"monitoring/uptime-check/">>(`monitoring/uptime-check/?${query}`);
}

export function getIncidentCount(params: Record<string, string | undefined>) {
    const query = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== "") as [string, string][],
    );
    return httpGet<GetRes<"jsm/incidents/count/">>(`jsm/incidents/count/?${query}`);
}
